import { Navigate, Outlet } from "react-router-dom";
// interface protected route
import { ProtectedRouteProps } from "../appconfig/interfaces";

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = localStorage.getItem("token");

  // check token available or not
  const isAuthenticated = token;
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (children) return <>{children}</>;

  return <Outlet />;
};

export default ProtectedRoute;
